<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.shopState" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品名称：">
                <el-input v-model.trim="searchForm.shopName" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgListPageHandle">搜索查询</el-button>
                <el-button type="primary" @click="showAddPkg">新增套餐</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >           
            <el-table-column prop="id" label="系统编码" width="120px"></el-table-column>
            <el-table-column prop="shopName" label="商品名称"></el-table-column>
            <el-table-column prop="shopPriceRmb" label="购买价"></el-table-column>
            <el-table-column prop="shopOldPriceRmb" label="原价" width="120px"></el-table-column>
            <el-table-column prop="shopFreeRmb" label="邮费" width="100px"></el-table-column>
            <el-table-column prop="shopAgentPriceRmb" label="代理商分润" width="100px"></el-table-column>
            <el-table-column prop="isShowAgentName" label="代理商可见" width="120px"></el-table-column>
            <el-table-column prop="shopStateName" label="状态" width="120px"></el-table-column>
            <el-table-column prop="buyCount" label="购买数" width="80px"></el-table-column>
            <el-table-column prop="collectCount" label="收藏数" width="120px"></el-table-column>
            <el-table-column label="排序">
                <template v-slot="scope">
                    <el-input v-model="scope.row.sort" maxlength="8" @change="updateSortNo(scope.row)" clearable></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="添加时间" width="200px"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <el-button type="text" size="small" @click="showEditPkg(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="changePkgStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                </template>             
            </el-table-column>
        </el-table>  
                 
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addPkgVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" label-width="120px">                
                <el-form-item label="商品名称:" prop="shopName">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.shopName" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="商品购买价：" prop="shopPrice">                    
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.shopPrice"></el-input>                        
                    </el-col>
                    <el-col :span="2" class="center">元</el-col> 
                </el-form-item>
                <el-form-item label="商品原价：" prop="shopOldPrice">
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.shopOldPrice"></el-input>
                    </el-col>
                    <el-col :span="2" class="center">元</el-col>                    
                </el-form-item>
                  <el-form-item label="商品展示图(建议像素512*512)：">
                    <input  type="file" ref="file1">
                    <div v-if="!existBackImg">商品图：</div>
                            <img v-else :src="addOrEditPkgForm.shopImgs" alt="" width="150" height="150">  
                </el-form-item>
                  <el-form-item label="商品详情图(建议像素1080*450)：">
                    <input  type="file" ref="file2">
                    <div v-if="!existBackImg">商品图：</div>
                            <img v-else :src="addOrEditPkgForm.shopHeadImg" alt="" width="150" height="150">  
                </el-form-item>
                <el-form-item label="状态：" prop="shopState">
                    <el-col :span="22">
                        <el-select v-model="addOrEditPkgForm.shopState" clearable>
                            <el-option v-for="item in pkgStatesOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                        </el-select>
                        
                    </el-col>
                </el-form-item> 
                  <el-form-item label="邮费：" prop="shopFree">
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.shopFree"></el-input>
                    </el-col>
                    <el-col :span="2" class="center">元</el-col>                    
                </el-form-item>
                <el-form-item label="代理商分润：" prop="shopAgentPrice">
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.shopAgentPrice"></el-input>
                    </el-col>
                    <el-col :span="2" class="center">元</el-col>                    
                </el-form-item>
                <el-form-item label="代理商可见订单：" prop="isShowAgent">
                    <el-col :span="22">
                        <el-select v-model="addOrEditPkgForm.isShowAgent" clearable>
                            <el-option v-for="item in agentStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item> 
                
                <el-form-item label="购买数：" prop="buyCount">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.buyCount" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                  <el-form-item label="收藏数：" prop="collectCount">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.collectCount" clearable></el-input>
                    </el-col>                    
                </el-form-item>
            <el-form-item label="排序：" prop="sort">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.sort" clearable></el-input>
                    </el-col>                    
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>            
        </el-dialog>
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){     
        return {
            frontImgUrl:'',
            existBackImg:false,
            searchForm: {
                typeGroupId: '',
                type: '',
                supplierType: '',
                shopState: null,
                shopName: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            pkgTypeOption: [],
            pkgStateOption: [
                {'code':1,'description':'上架'},
              {'code':2,'description':'下架'}
            ],
              pkgStatesOption: [
                {'code':1,'description':'上架'},
              {'code':2,'description':'下架'}
            ],
             agentStateOption: [
                {'code':1,'description':'允许'},
              {'code':2,'description':'不允许'}
            ],
            supplierOption: [],
            addOrEditPkgForm: {
                shopName: '',
                shopPrice: '',
                shopImgs: '',
                shopState: '',
                shopOldPrice: '',
                shopFree: '',
                shopAgentPrice:'',
                isShowAgent: '',
                shopHeadImg: '',
                buyCount: 0,
                collectCount: 0 ,
                sort:0  ,
                         
            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: ''
        }
    },
    methods: {
        cancel(){
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '上架', 1: '下架'})
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

                 common.sysRequest('app/pc/store/list', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增商品';
        },
        showEditPkg(row){
            this.existBackImg=true;
            this.frontImgUrl=true;
            this.addPkgVisibale = true;
            this.addFlag = false;
            this.title = '修改商品';  
            this.currentId = row.id;   
            var data = {
                id: row.id
            }
            this.existBackImg=true;

            common.sysRequest("app/pc/store/infos", data, 'post').then(res=>{
                     var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    
                        this.addOrEditPkgForm[key] = result[key]
                }        
                      }).catch(err=> console.error(err));
                         
        },
        addOrEidtPkgHandle(){
            this.$refs.addOrEditPkgForm.validate(valid => {
                if(valid) {
                    let fd = new FormData();
            Object.keys(this.addOrEditPkgForm).forEach((key) => {
                fd.append(key, this.addOrEditPkgForm[key]);
            })
            fd.append('appPopImg',this.$refs.file1.files[0]);
            fd.append('appTImg',this.$refs.file2.files[0]);
                    if(this.addFlag == true){
                        common.sysRequest("app/pc/insert/store", fd, 'post').then(res=>{
                                if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                     callback(res);
                            for (let val in this.addOrEditPkgForm) {
                                this.addOrEditPkgForm[val] = "";
                            }

                            }else{
                                this.$message.error(res.data.message);
                            }
                      }).catch(err=> console.error(err));
                    }else{
                         fd.append('id',this.currentId);
                           common.sysRequest("app/pc/update/store", fd, 'post').then(res=>{
                             if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                 callback(res);
                            }else{
                                this.$message.error(res.data.message);
                            }
                           
                      }).catch(err=> console.error(err));             
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgListPageHandle();
                        _this.addPkgVisibale = false;
                        
                    }else{                        
                        _this.$message.error(res.data.message)
                    }                     
                }
            })             
        },
        changePkgStateHandle(id){
            var data = {
                id
            }
            changePkgState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getPkgListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
             common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                    if(res.data.code == 200){
                    this.getPkgListPageHandle();
                   }
                })
            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
        this.getPkgListPageHandle();
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getPkgTypeOptionCom(this, 'pkgTypeOption');
        common.getSupplierOptionCom(this, 'supplierOption');
    }  
}
</script>
<style lang="less" >
.input-with-select .el-input {
    width: 60px;
}
</style>

